const vcxRedirects = {
	routeName: 'vcx-landing',
	regExPaths: ['^/campaigns/venture$', '^/partner/venture$', '^/campaigns/fund/innovation$'].join('|')
};

export default vcxRedirects;
